import { FC } from 'react';
import { ProposalResponse } from 'pages/ProposalDetail';
import { VotingSystem } from 'types/snapshot';
import RankedForm from './forms/RankedForm';
import SelectForm from './forms/SelectForm';
import WeightedForm from './forms/WeightedForm';

type Props = {
  proposal: ProposalResponse;
};

const VotingFormContainer: FC<Props> = ({ proposal }) => {
  return (
    <>
      {(proposal.proposal.type === VotingSystem.APPROVAL ||
        proposal.proposal.type === VotingSystem.SINGLE_CHOICE) && (
        <SelectForm proposal={proposal.proposal} />
      )}
      {(proposal.proposal.type === VotingSystem.QUADRATIC ||
        proposal.proposal.type === VotingSystem.WEIGHTED) && (
        <WeightedForm proposal={proposal.proposal} />
      )}
      {proposal.proposal.type === VotingSystem.RANKED_CHOICE && (
        <RankedForm proposal={proposal.proposal} />
      )}
    </>
  );
};

export default VotingFormContainer;
